export const local = {
	adminUtl:			'http://localhost/4200',
	GapMaps2APP:		'http://localhost:3000',
	locationAPIUrl:		'http://localhost:8094/gapmaps',
	businessAdminAPIUrl:'http://localhost:3001',
	dbUrl:				'http://localhost:3001',
	authUrl:			'http://localhost:9323',
	geocoderUrl:		'http://localhost:8095',
	layersUrl:			'http://localhost:3002',

	demographicsUrl:	'http://localhost:3000/api',
	metadataUrl:		'http://localhost:8093/gapmaps/1.0/meta',
	retailerUrl:		'http://localhost:3001',
	storageUrl:			'http://localhost:8093',
	scraperUrl:			'http://localhost:3001',
	analyticsApiUrl :	'http://localhost:3001',
};

export const proxy = {
	...local,
	GapMaps2APP: 'https://gapmaps-live.localhost',
	authUrl: 'https://gapmaps-auth.localhost',
	layersUrl: 'https://gapmaps-layers-api.localhost',
	locationAPIUrl: 'https://gapmaps-location2-api.localhost/gapmaps',
	businessAdminAPIUrl: 'https://gapmaps-business-admin-api.localhost'
}

export const test = {
	adminUrl:			   'https://test-admin-api.gapmaps.com',
	authUrl:			   'https://test-auth.gapmaps.com',
	businessAdminAPIUrl:   'https://test-business-admin-api.gapmaps.com',
	GapMaps2APP:		   'https://test-live.gapmaps.com',
	layersUrl:			   'https://test-layers-api.gapmaps.com',
	locationAPIUrl:		   'https://test-location2-api.gapmaps.com/gapmaps',
};

export const staging = {
	GapMaps2APP:		'https://staging-live.gapmaps.com',
	locationAPIUrl:		'https://staging-location2-api.gapmaps.com/gapmaps',
	businessAdminAPIUrl:'https://staging-business-admin-api.gapmaps.com',
	dbUrl:				'https://staging-data.gapmaps.com',
	authUrl:			'https://staging-auth.gapmaps.com',
	geocoderUrl:		'https://staging-geocoder.gapmaps.com',

	adminUrl:			'https://staging-admin-api.gapmaps.com',
    analyticsApiUrl:	'https://staging-analytics-api.gapmaps.com',
	demographicsUrl:	'https://staging-demographics-api.gapmaps.com',
	imageBucket:		'gapmaps-staging-images',
	imageBaseUrl:		'https://staging-images.gapmaps.com',
	marketReportsUrl:	'https://staging-marketreports.gapmaps.com',
	metadataUrl:		'https://staging-storage-api.gapmaps.com/gapmaps/1.0/meta',
	retailerUrl:		'https://staging-retailers.gapmaps.com/gapmaps/1.0/retailer',
    retailersUrl:		'https://staging-retailers.gapmaps.com/gapmaps/1.0/retailer',
    scraperUrl:			'https://staging-scraper-api.gapmaps.com',
	storageUrl:			'https://staging-storage-api.gapmaps.com',
	areasUrl:			'https://staging-retailers.gapmaps.com/gapmaps/1.0/area',
	webPushBrokerUrl:	'https://staging-broker-api.gapmaps.com',
	layersUrl:			'https://staging-layers-api.gapmaps.com',
	poiAPIUrl:			'https://staging-poi-api.gapmaps.com',
	keycloak: {
        url: 'https://staging-auth1.gapmaps.com',
        adminUrl: 'https://staging-auth1-admin.gapmaps.com',
        realm: 'gapmaps',
        clientId: 'gapmaps2-app',
    },
};

export const prod = {
};
